import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { examinationsubjects } from './examination-subjects';

@Injectable()
export class ExaminationSubjectService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getSubjectList(personId: string): Observable<examinationsubjects[]> {
    const url = this.urlSignature.subjectsUrl + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as examinationsubjects[]));
  }
}
